export enum XmlType {
  String,
  Number,
  Boolean,
  Array,
  Object,
  Date,
}
